import request from "@/utils/request";

// 列表(主数据列表)
export function loadReceivableListDataApi(data) {
  return request({
    url: "web/receivable/listData",
    method: "post",
    data
  });
}
// 导出
export function loadReceivableExportDataApi(data) {
  return request({
    url: "web/receivable/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateReceivableApi(data) {
  return request({
    url: "web/receivable/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initReceivableApi(data) {
  return request({
    url: "web/receivable/init",
    method: "post",
    data
  });
}

// 获取待处理数量
export function countReceivableTodoNumberApi(data) {
  return request({
    url: "web/receivable/countTodoNumber",
    method: "post",
    data
  });
}

// 根据条件获取应收单明细
export function findReceivableDetailByConditionApi(data) {
  return request({
    url: "web/receivable/findDetailByCondition",
    method: "post",
    data
  });
}

// 根据条件获取应收单税率开票明细合计
export function findSumReceivableRateDetailByConditionApi(data) {
  return request({
    url: "web/receivable/findSumRateDetailByCondition",
    method: "post",
    data
  });
}

// 根据应收单IDs查询方案服务金额和管理费金额差异
export function findSchemeServiceAmountAndManageFeeDiffApi(data) {
  return request({
    url: "web/receivable/findSchemeServiceAmountAndManageFeeDiff",
    method: "post",
    data
  });
}
